export const REDUCER_AUTH_LOGIN = 'REDUCER_AUTH_LOGIN'
export const REDUCER_AUTH_VERIFY = 'REDUCER_AUTH_VERIFY'
export const REDUCER_AUTH_LOGOUT = 'REDUCER_AUTH_LOGOUT'
export const REDUCER_AUTH_PARKS_INFO = 'REDUCER_AUTH_PARKS_INFO'
